
















import {Component, Inject, Prop, Vue, Watch} from "vue-property-decorator";
import MessageService from "../services/MessageService";
import GlobalEventBus from "../mixins/GlobalEventBus";
import MessageItem from "./MessageItem.vue";

@Component
export default class MessageList extends Vue {

  @Prop()
  onSelectedItem?: (data: any, event: MouseEvent) => void;

  @Prop()
  type?: 'inbox' | 'draft' | 'archived' | 'trash';

  @Inject()
  // @ts-ignore
  private messageService: MessageService;
  private items: Array<any> = [];
  private itemComponent = MessageItem;
  private isLoading = true;
  private refreshTimeout?: number;
  private totalRecords = 0;
  private currentPage = 1;
  private canNextPage = false;

  get itemExtraProps(): object {
    return {
      onClick: this.onClickItem
    };
  }

  onClickItem(id: number, event: MouseEvent) {
    if (this.onSelectedItem) {
      const selectedItem = this.items.filter(d => d.id === id)[0];
      this.onSelectedItem(selectedItem, event);
    }
  }

  refresh() {
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
    const all = [];
    all.push(this.loadItems(true));
    Promise.all(all).then(() => {
      this.refreshTimeout = setTimeout(this.refresh, 15000);
    }).catch(() => {
      this.refreshTimeout = setTimeout(this.refresh, 15000);
    })
  }

  mounted() {
    GlobalEventBus.$on('updated-auth', this.loadItems);
    GlobalEventBus.$on('seen-message', this.refreshItem);
    GlobalEventBus.$on('refreshed-message', this.refreshedItem);
    GlobalEventBus.$on('deleted-message', this.deletedItem);
    this.refreshTimeout = setTimeout(this.refresh, 15000);
    this.loadItems();
  }

  @Watch('type')
  changedType() {
    this.currentPage = 1;
    this.loadItems();
  }

  beforeDestroy() {
    GlobalEventBus.$off('updated-auth', this.loadItems);
    GlobalEventBus.$off('seen-message', this.refreshItem);
    GlobalEventBus.$off('refreshed-message', this.refreshedItem);
    GlobalEventBus.$off('deleted-message', this.deletedItem);
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
  }

  deletedItem(data: any) {
    this.items = this.items.filter(d => d.id !== data.id);
  }

  refreshedItem(data: any) {
    const selected = this.items.filter(d => d.id === data.id);
    if (selected.length > 0) {
      const index = this.items.indexOf(selected[0]);
      if (this.type === "draft" && data.sent_at) {
        this.items.splice(index, 1);
      } else {
        this.items[index] = data;
      }
      this.$forceUpdate();
    }
  }

  refreshItem(data: any) {
    if (this.items.filter(d => d.id === data.id).length > 0) {
      this.messageService.getMessage(data.id).then(response => {
        this.refreshedItem(response.data);
      });
    }
  }

  public onScrollToBottom(e: any) {
    if (this.isLoading || !this.canNextPage) {
      return;
    }
    this.currentPage++;
    this.loadItems();
  }

  public loadItems(checkLatest?: boolean) {
    let draft = false;
    let deleted = false;
    let archived = false;
    let lastModifiedAt: string | undefined = undefined;
    if (this.type === "draft") {
      draft = true;
    } else if (this.type === "archived") {
      archived = true;
    } else if (this.type === "trash") {
      deleted = true;
    }
    if (checkLatest) {
      if (this.items.length > 0) {
        lastModifiedAt = this.items[0].modified_at;
      }
    } else {
      this.isLoading = true;
    }
    return this.messageService.getMessages(checkLatest ? 1 : this.currentPage, checkLatest ? 10 : 30, undefined, deleted, archived, draft, lastModifiedAt).then(response => {
      if (checkLatest) {
        for (const messageItem of response.data.results.reverse()) {
          const oldItem = this.items.filter(d => d.id === messageItem.id);
          if (oldItem.length > 0) {
            this.items[this.items.indexOf(oldItem)] = messageItem;
          } else {
            this.items.unshift(messageItem);
          }
        }
        this.$forceUpdate();
      } else if (this.currentPage > 1) {
        for (const messageItem of response.data.results) {
          const oldItem = this.items.filter(d => d.id === messageItem.id);
          if (oldItem.length > 0) {
            this.items[this.items.indexOf(oldItem)] = messageItem;
          } else {
            this.items.push(messageItem);
          }
        }
        this.$forceUpdate();
        this.totalRecords = response.data.count;
        this.canNextPage = !!response.data.next;
      } else {
        this.totalRecords = response.data.count;
        this.items = response.data.results;
        this.canNextPage = !!response.data.next;
      }
      this.isLoading = false;
    });
  }
}

